import React, { FC } from 'react';

import { FlexView } from '../../elements';
const ContentGroupWrapper: FC = ({ children }) => (
  <FlexView
    width={['100vw', '100vw', '100%']}
    px="L"
    zIndex={2}
    flexDirection="column"
  >
    {children}
  </FlexView>
);

export default ContentGroupWrapper;
